(ns rothko.header.styles
  (:require [garden.selectors :as selectors]
            [garden.stylesheet :refer [at-media]]
            [garden.units :as units]
            [medley.core :refer [filter-vals]]
            [rothko.styles.vars.basic :as basic]
            [rothko.styles.media :refer [tablet]]
            [utility-belt.pure :refer [create-keyword]]))

(def header-height-rems 6)
(def header-height (units/rem header-height-rems))
(def mobile-header-height-rems 4)
(def mobile-header-height (units/rem mobile-header-height-rems))
(def mobile-header-padding-rems 0.55)
(def burger-bun-width-px 25)

(def menu-icon
  {:fill (:white basic/colours)
   :position :absolute
   :left "50%"
   :top "50%"
   :transform "translate(-50%, -50%)"})

(def menu-icon-container
  {:transition-duration (:fast basic/durations)
   :transition-property :transform
   :transition-timing-function :ease-in-out})

(def menu-icon-cross--hidden
  {:transform "translate(0, -60px)"})

(def menu-icon-bars--hidden
  {:transform "translate(60px, 0)"})

(def hamburger-menu-button
  [:.hamburger-menu-button])

(def hamburger-menu-icon-container
  [:.hamburger-menu-icon-container
   {:position :relative
    :display :flex
    :align-items :center
    :justify-content :center
    :overflow :hidden}])

(def logo
  [:.header-title {:display :inline
                   :fill :white
                   :font-size 0
                   :line-height 0
                   :padding 0}])
(def login-button
  [:a.login-btn {:color :white
                 :cursor :pointer
                 :text-decoration :none
                 :display :flex}
   [:.icon-container {:display :flex
                      :margin-right (units/rem 1)
                      :align-items :center}
    (tablet {:margin-right (units/rem 2)})
    [:span {:display :none
            :line-height "19px"}
     (tablet {:display :initial})]
    [:svg {:margin-right (units/px 10)
           :fill (:white basic/colours)}]]])

(defn header
  [styles]
  [:header
   {:align-items :center
    :box-shadow (:header-shadow basic/shadows)
    :color (:white basic/colours)
    :display :flex
    :grid-area "header"
    :height mobile-header-height
    :width (units/percent 100)}

   (for [[style-name style] styles]
     [(selectors/& "." style-name)
      {:background-color (:background-color style)}])

   (tablet {:height header-height})

   [:h1 :h2 :h3 :h4 :h5 :h6 {:padding 0}]

   [:.header-left-container
    {:flex [[1 0 0]]
     :display :flex
     :margin-left (units/rem 1)}
    logo]

   [:.header-right-container
    {:display :flex}
    [:.header-right-container-inner
     {:margin-left :auto
      :margin-right (units/rem 1)
      :display :flex}
     (tablet {:margin-right (units/rem 2)})]
    login-button]

   [:.header-side-nav
    {:position :fixed
     :right 0
     :bottom 0
     :top mobile-header-height
     :background-color (:white basic/colours)
     :transform "translate3d(100vw, 0, 0)"
     :transition-duration (:fast basic/durations)
     :transition-property :transform
     :transition-timing-function :ease-in-out
     :z-index 10}
    (tablet {:top header-height})
    [:&.open
     {:transform "translate3d(0vw, 0, 0)"}]]])

(defn main
  [styles]
  [(header styles)
   hamburger-menu-button
   hamburger-menu-icon-container
   login-button])
